import { ChangeDetectionStrategy, Component, Input, OnChanges } from "@angular/core";

import { formatDate } from "@dffedb/util";
import { MaalerOplysninger } from "@e-forsyning/common/maaler";

@Component({
    selector: "servicerapport-maaler-oplysninger",
    templateUrl: "./servicerapport-maaler-oplysninger.component.html",
    styleUrls: ["./servicerapport-maaler-oplysninger.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicerapportMaalerOplysningerComponent implements OnChanges {
    protected oplysninger: { key: string; value: string }[] = [];
    @Input() public data: MaalerOplysninger;

    public ngOnChanges(): void {
        this.udfyldOplysninger();
    }

    public udfyldOplysninger(): void {
        this.oplysninger = [];
        if (!this.data) {
            return;
        }

        this.oplysninger.push({ key: "Forbrugernr.", value: this.getValue(this.data.ejendomNr) });
        this.oplysninger.push({ key: "Målernr.", value: this.getValue(this.data.maalerNr) });
        this.oplysninger.push({ key: "Målertype", value: this.getValue(this.data.maalerType.tekst) });
        this.oplysninger.push({ key: "Seneste service", value: this.getValue(this.data.sidsteServiceDato) });
        this.oplysninger.push({ key: "Info 1", value: this.getValue(this.data.info1) });
        this.oplysninger.push({ key: "Info 2", value: this.getValue(this.data.info2) });
    }

    private getValue(value: any): string {
        if (value === undefined || value === null) {
            return "";
        }

        if (value instanceof Date) {
            return formatDate(value, "Do MMMM YYYY");
        }

        return value.toString();
    }
}
